export default {
  // apiUrl: "http://iot.yw/api.php/",
  // apiUrl: "http://work.elecon.cn:949/api.php/",
  // hBaseUrl: "http://180.166.23.62:1888/",
  // staticFile: "http://work.elecon.cn:949/",
  // staticFilePrefix: "http://work.elecon.cn:949",

  // apiUrl: "https://api.mynoark.au/api.php/",
  // hBaseUrl: "http://52.63.159.241:1888/",
  // staticFile: "https://api.mynoark.au/",.
  // staticFilePrefix: "https://api.mynoark.au",
  // messageUrl: "http://180.166.23.62:18888/",

  apiUrl: 'https://api.mynoark.au/api.php/',
  hBaseUrl: 'https://api.mynoark.au/proxy_hbase/',
  staticFile: 'https://api.mynoark.au/',
  staticFilePrefix: 'https://api.mynoark.au',

  // apiUrl: "https://api.123123456.xyz/api.php/",
  // staticFile: "https://api.123123456.xyz/",
  // staticFilePrefix: "https://api.123123456.xyz",
  // messageUrl: "http://52.63.159.241:1888/",
  // prefix: "ZTGJYW",

  // apiUrl: "https://api.mynoark.com.au/api.php/",
  // hBaseUrl: "https://api.mynoark.com.au/proxy_hbase/",
  // staticFile: "https://api.mynoark.com.au/",
  // staticFilePrefix: "https://api.mynoark.com.au",

  prefix: 'MYNOARK',
  // prefix: "LIANGM",
  prefix_name: 'MYNOARK',
  // prefix_name: "NOARK",

  googleApiKey: 'AIzaSyAQ4lKsugGfV0Y5VX57LMnzqpkf-UHcCes',
}
